(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kairos-customer-reviews-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kcr').forEach((section) => {
    const rail = section.querySelector('[data-kcr-rail]');
    section.querySelector('[data-kcr-rail-prev]').addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .75, behavior: 'smooth' }));
    section.querySelector('[data-kcr-rail-next]').addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .75, behavior: 'smooth' }));
    section.querySelectorAll('[data-kcr-open]').forEach((button) => {
      button.addEventListener('click', () => section.querySelector(`[data-kcr-dialog="${button.dataset.kcrOpen}"]`).showModal());
    });
    section.querySelectorAll('[data-kcr-dialog]').forEach((dialog) => {
      let active = 0;
      const photos = [...dialog.querySelectorAll('[data-kcr-photo]')];
      const count = dialog.querySelector('[data-kcr-count]');
      const render = () => {
        photos.forEach((photo, index) => photo.hidden = index !== active);
        if (count) count.textContent = `${active + 1} / ${photos.length}`;
      };
      dialog.querySelector('[data-kcr-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.querySelector('[data-kcr-prev]')?.addEventListener('click', () => { active = (active - 1 + photos.length) % photos.length; render(); });
      dialog.querySelector('[data-kcr-next]')?.addEventListener('click', () => { active = (active + 1) % photos.length; render(); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kairos-customer-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kcr').forEach((section) => {
    const productId = section.dataset.kcrProductId;
    const reviewWidgets = window.jdgm?.data?.reviewWidget || {};
    const judgeMeReviewCount = Number(reviewWidgets[productId]?.number_of_reviews || 0);
    if (judgeMeReviewCount > 0) {
      section.remove();
      return;
    }
    section.removeAttribute('data-kcr-pending');
    const rail = section.querySelector('[data-kcr-rail]');
    section.querySelector('[data-kcr-rail-prev]').addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .75, behavior: 'smooth' }));
    section.querySelector('[data-kcr-rail-next]').addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .75, behavior: 'smooth' }));
    section.querySelectorAll('[data-kcr-open]').forEach((button) => {
      button.addEventListener('click', () => section.querySelector(`[data-kcr-dialog="${button.dataset.kcrOpen}"]`).showModal());
    });
    section.querySelectorAll('[data-kcr-dialog]').forEach((dialog) => {
      let active = 0;
      const photos = [...dialog.querySelectorAll('[data-kcr-photo]')];
      const count = dialog.querySelector('[data-kcr-count]');
      const render = () => {
        photos.forEach((photo, index) => photo.hidden = index !== active);
        if (count) count.textContent = `${active + 1} / ${photos.length}`;
      };
      dialog.querySelector('[data-kcr-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.querySelector('[data-kcr-prev]')?.addEventListener('click', () => { active = (active - 1 + photos.length) % photos.length; render(); });
      dialog.querySelector('[data-kcr-next]')?.addEventListener('click', () => { active = (active + 1) % photos.length; render(); });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
